import { createReducer, on } from '@ngrx/store';
import { initialAuthState } from './auth.state';
import * as AuthActions from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.clearAuthError, (state) => ({
  ...state,
  error: null,
})),

  on(AuthActions.hydrateSuccess, (state, { token, roles }) => ({
    ...state,
    isAuthenticated: true,
    token,
    roles,
    loading: false,
    error: null,
  })),

  on(AuthActions.hydrateFailure, (state) => ({
    ...state,
    isAuthenticated: false,
    token: null,
    roles: [],
    loading: false,
    error: null,
  })),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    token: null,
    roles: [],
    loading: false,
    error,
  })),

  on(AuthActions.logoutSuccess, () => initialAuthState)
);
